import React, { useEffect, useRef, useState } from "react";

import { map } from 'lodash';

import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import { size } from "lodash";
import { motion } from "framer-motion";

import mobBanner from "@/assets/images/webp/mobile_hero_banner.webp";
import deskBanner from "@/assets/images/webp/hero_banner.webp";

const HeroBanner = ({ heroBanners }) => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const sectionRef = useRef(null);
  const [banners, setBanners] = useState([]);

  const options = {
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    animateOut: 'fadeOut',
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
      1280: { items: 1 },
      1440: { items: 1 },
    },
  };

  useEffect(() => {
    if (size(heroBanners) > 0 && size(banners) === 0) {
      setBanners(heroBanners);
    }
  }, [heroBanners, banners]);

  return (
    <section ref={sectionRef} className="hero-banner-wrape">
      {
        size(banners) === 0 && <div className="owl-theme">
          <div className="slide-main-frame" key={`silde-main-frame-static`}>
            <motion.picture
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6 }}
            >
              <source media="(max-width: 767px)" srcSet={mobBanner} />
              <img
                src={deskBanner}
                className="hero-slide-bg"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                alt="Hero Banner"
                width={1920}
                height={523}
              />
            </motion.picture>
          </div>
        </div>
      }
      {
        size(banners) > 0 && <OwlCarousel className="owl-theme" {...options} >
          {
            banners && map(banners, (val, k) => {
              return (
                <div className="slide-main-frame" key={`silde-main-frame-${k}`}>
                  <motion.picture
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.6 }}
                  >
                    <source media="(max-width: 767px)" srcSet={val.mobile_image} type="image/webp" />
                    <img
                      src={val.image}
                      className="hero-slide-bg"
                      loading="lazy" // eager
                      fetchpriority="auto" // high
                      decoding="async"
                      alt="Hero Banner"
                      width={770}
                      height={652}
                    />
                  </motion.picture>


                  <div className="container">
                    <div className="slider-text">
                      <div className="content-wrape">
                        {/* <h2>{val?.title}</h2> */}

                        <motion.h2
                          dangerouslySetInnerHTML={{
                            __html: val?.title,
                          }}
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.5 }}
                          custom={0.3}
                          variants={fadeUpVariant}
                          className="animate-child"
                        >

                        </motion.h2>
                        {val?.sub_title && <motion.p
                          className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.5 }}
                          custom={0.3}
                          variants={fadeUpVariant}
                        >{val.sub_title}</motion.p>

                        }

                        {val?.button_label && val?.url && (() => {
                          const isExternal = !val.url.startsWith("/");
                          const normalizedUrl = isExternal
                            ? val.url.startsWith("http")
                              ? val.url
                              : `https://${val.url}`
                            : val.url;

                          return isExternal ? (
                            <motion.div
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.5 }}
                              custom={0.5}
                              variants={fadeUpVariant}
                            >
                              <Link
                                to={normalizedUrl}
                                href={normalizedUrl}
                                title={val.url}
                                className="btn group-btn"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {val.button_label}
                                <span className="round">
                                  <i className="sprite"></i>
                                </span>
                              </Link>

                              <i className="sprite arrows"></i>
                            </motion.div>
                          ) : (
                            <motion.div
                              className="animate-child"
                            >
                              <Link
                                to={normalizedUrl}
                                title={val.url}
                                className="btn group-btn"
                              >
                                {val.button_label}
                              </Link>
                            </motion.div>
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                </div>

              )
            })
          }
        </OwlCarousel>
      }

    </section>
  );
}

export default HeroBanner;
